/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Dates_RequiredInputs */

const en_rental_dates_required = /** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select check-in and check-out dates to continue.`)
};

const es_rental_dates_required = /** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor selecciona las fechas de check-in y check-out para continuar.`)
};

const fr_rental_dates_required = /** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner les dates d'arrivée et de départ pour continuer.`)
};

const de_rental_dates_required = /** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähle Check-in- und Check-out-Daten aus, um fortzufahren.`)
};

const id_rental_dates_required = /** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap pilih tanggal check-in dan check-out untuk melanjutkan.`)
};

/** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */
const ja_rental_dates_required = en_rental_dates_required;

/** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */
const zh_rental_dates_required = en_rental_dates_required;

/** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */
const ar_rental_dates_required = en_rental_dates_required;

/** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */
const it_rental_dates_required = en_rental_dates_required;

/** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */
const ru_rental_dates_required = en_rental_dates_required;

/** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */
const pt_rental_dates_required = en_rental_dates_required;

/** @type {(inputs: Rental_Dates_RequiredInputs) => LocalizedString} */
const ko_rental_dates_required = en_rental_dates_required;

/**
* | output |
* | --- |
* | "Please select check-in and check-out dates to continue." |
*
* @param {Rental_Dates_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_dates_required = /** @type {((inputs?: Rental_Dates_RequiredInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Dates_RequiredInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_dates_required(inputs)
	if (locale === "es") return es_rental_dates_required(inputs)
	if (locale === "fr") return fr_rental_dates_required(inputs)
	if (locale === "de") return de_rental_dates_required(inputs)
	if (locale === "ja") return ja_rental_dates_required(inputs)
	if (locale === "zh") return zh_rental_dates_required(inputs)
	if (locale === "ar") return ar_rental_dates_required(inputs)
	if (locale === "id") return id_rental_dates_required(inputs)
	if (locale === "it") return it_rental_dates_required(inputs)
	if (locale === "ru") return ru_rental_dates_required(inputs)
	if (locale === "pt") return pt_rental_dates_required(inputs)
	return ko_rental_dates_required(inputs)
});